const defaultText = '-'

export function getEmptyText(text?: string) {
  return !text || text === '' ? defaultText : text
}
